import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import searcher from "../../../assets/searchInput.svg";
import "./bulk-upload.css";
import { useDispatch } from "react-redux";
import TableContainer from "../../layouts/table-container/table-container";
import { productBulkVerify } from "../../../redux/actions/divisionAction";
import ErrorPopup from "../../popups/ErrorPopup";
import ChangeSaved from "../../popups/ChangeSaved";

const ProductDataVerificationModal = ({
  show,
  ShowClose,
  productData,
  vendor_id,
  division_id,
  deleteModalOpener,
}) => {
  const [bulkUploadData, setBulkUploadData] = useState([]);
  const [productVerifiedList, setProductVerifiedList] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const dispatch = useDispatch();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  const checkedProduct = (e, data) => {
    const { checked } = e.target;
    let newArr = productVerifiedList;
    setProductVerifiedList([...newArr, data]);
    if (!checked) {
      setProductVerifiedList(
        productVerifiedList.filter(
          (item) => JSON.stringify(item) !== JSON.stringify(data)
        )
      );
    }
  };

  useEffect(() => {
    console.log(productVerifiedList);
    if (productVerifiedList?.length != productData?.productData?.length) {
      setIsCheckAll(false);
    } else {
      setIsCheckAll(true);
    }
  }, [productVerifiedList]);

  useEffect(() => {
    setBulkUploadData(productData?.productData);
  }, [productData]);

  const productDeleteHandler = (indexToRemove) => {
    let newArray = productData.productData;
    newArray.splice(indexToRemove, 1);
    setBulkUploadData(newArray);
    console.log(newArray, "delete");
  };

  const searchHandler = (e) => {
    let newArr = productData.productData.filter(
      (product) =>
        product.product_name
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        product.company_product_id
          .toLowerCase()
          .includes(e.target.value.toLowerCase())
    );
    setBulkUploadData(newArr);
  };

  const verifyProductHandler = () => {
    dispatch(
      productBulkVerify(
        { productData: productVerifiedList, vendor_id, division_id },
        onVerifySuccess,
        onVerifyError
      )
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
  };

  const onVerifySuccess = (data) => {
    console.log(data);
    ShowClose();
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
    setProductVerifiedList([]);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onVerifyError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
    setProductVerifiedList([]);
  };

  const checkAll = (e) => {
    const { checked } = e.target;
    setIsCheckAll(checked);
    if (checked) {
      setProductVerifiedList(productData?.productData);
    } else {
      setProductVerifiedList([]);
    }
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        dialogClassName="product-data-table-container col-11 px-5 mx-auto"
        size="lg"
      >
        <ModalHeader className="d-flex justify-content-between align-items-center">
          <div>
            <span className="fn_Nunito fw_600 fs_18">
              Product Data Verification -
              <span className="fw_500">
                {productData?.original_name?.length > 35
                  ? productData?.original_name?.substring(0, 35) + "..."
                  : productData?.original_name}
              </span>
            </span>
          </div>
          <div className=" d-flex justify-content-between m-1 mb-2">
            <AdminButton
              background="#E7E5FF"
              width="100px"
              type="button"
              onClick={() => ShowClose()}
            >
              CLOSE
            </AdminButton>
            <AdminButton
              background="#2AD3E7"
              color="white"
              width="100px"
              type="submit"
              disabled={productVerifiedList?.length == 0}
              onClick={verifyProductHandler}
            >
              <span className="m-2">VERIFY</span>
            </AdminButton>
          </div>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div className="modal-table-container">
            <div className="search-container d-flex justify-content-between ">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  className="search-input fw_400 px-2"
                  type="text"
                  placeholder="Search Product here by Product Name..."
                  onChange={searchHandler}
                />
              </div>
            </div>
            <TableContainer>
              <thead>
                <tr className="table-rows color_747f9e">
                  <th className="table-heads" width={"6%"}>
                    <input
                      type={"checkbox"}
                      className="CheckBox my-1"
                      value="Full order forward from CFA"
                      name="ReimbursementCheck"
                      checked={isCheckAll}
                      onChange={checkAll}
                    />
                  </th>
                  <th className="table-heads " width={"8%"}>
                    SL. No
                  </th>
                  <th className="table-heads " width={"15%"}>
                    Company’s Product ID
                  </th>
                  <th className="table-heads " width={"15%"}>
                    Product Name
                  </th>
                  <th className="table-heads " width={"15%"}>
                    Division Name
                  </th>
                  <th className="table-heads " width={"15%"}>
                    MRP
                  </th>
                  <th className="table-heads " width={"15%"}>
                    PTR
                  </th>
                  <th className="table-heads " width={"15%"}>
                    PTS
                  </th>
                  <th className="table-heads " width={"15%"}>
                    Quantity
                  </th>
                  <th className="table-heads " width={"15%"}>
                    Offer Qty
                  </th>
                </tr>
              </thead>
              {bulkUploadData?.length > 0 &&
                bulkUploadData?.map((data, index) => (
                  <tbody>
                    <tr className="table-rows1" key={index}>
                      <td className="table-each-row-data" width={"6%"}>
                        <input
                          type="checkbox"
                          className="CheckBox my-1"
                          id="index"
                          name="prodcutsCheck"
                          onChange={(e) => checkedProduct(e, data)}
                          checked={productVerifiedList.includes(data)}
                        />
                      </td>
                      <td className="table-each-row-data">{data?.sl_no}</td>
                      <td className="table-each-row-data">
                        {data?.company_product_id}
                      </td>
                      <td className="table-each-row-data">
                        {data?.product_name}
                      </td>
                      <td className="table-each-row-data">
                        {data?.division_name}
                      </td>
                      <td className="table-each-row-data">{`₹ ${data?.mrp}`}</td>
                      <td className="table-each-row-data">{`₹ ${data?.ptr}`}</td>
                      <td className="table-each-row-data">{`₹ ${data?.pts}`}</td>
                      <td className="table-each-row-data">{`${data?.quantity}`}</td>
                      <td className="table-each-row-data">{`${data?.offer_qty}`}</td>
                      {/* <td className="table-each-row-data ">
                        <div className="all-button d-flex align-items-center">
                          <button
                            className="button-disable"
                            type="button"
                            color={"green"}
                            onClick={() => productDeleteHandler(index)}
                          >
                            Delete
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  </tbody>
                ))}
            </TableContainer>
          </div>
        </ModalBody>
      </Modal>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default ProductDataVerificationModal;
